import api from '@services'
import { stripEmptyObjects } from '@utils'

const serviceBaseUrl = process.env.REACT_APP_DRIVING_TEST_BASE_URL ?? ''
const servicePrefix = `${serviceBaseUrl}/svc/driving-test/api`

//driving license application
export const getDrivingTestConfigurations = async (params) => {
  const response = await api.get(`${servicePrefix}/test-configurations`, { params: stripEmptyObjects(params) })
  return response.data
}

export const addDrivingTestConfiguration = async (data) => {
  const response = await api.post(`${servicePrefix}/test-configurations`, data)
  return response.data
}

export const getDrivingTestConfiguration = async (id) => {
  const response = await api.get(`${servicePrefix}/test-configurations/${id}`)
  return response.data
}

export const getDrivingTestConfigurationWithBookings = async (id) => {
  const response = await api.get(`${servicePrefix}/test-configurations/${id}/test-bookings`)
  return response.data
}

export const updateDrivingTestConfiguration = async (id, data) => {
  const response = await api.patch(`${servicePrefix}/test-configurations/${id}`, data)
  return response.data
}

export const deleteDrivingTestConfiguration = async (id) => {
  const response = await api.delete(`${servicePrefix}/test-configurations/${id}`)
  return response.data
}

//Driving Test Candidates

export const getDrivingTestCandidates = async (params) => {
  const response = await api.get(`${servicePrefix}/test-bookings`, { params: stripEmptyObjects(params) })
  return response.data
}

export const getDrivingTestCandidatesByTestConfigurationId = async (id) => {
  const response = await api.get(`${servicePrefix}/test-configurations/${id}/practical-candidates`)
  return response.data
}

export const getDrivingTestCandidate = async (id) => {
  const response = await api.get(`${servicePrefix}/test-bookings/${id}`)
  return response.data
}

//Driving Test Theory Questions
export const getTestQuestions = async (params) => {
  const response = await api.get(`${servicePrefix}/questions`, { params: stripEmptyObjects(params) })
  return response.data
}

export const getTestQuestion = async (id) => {
  const response = await api.get(`${servicePrefix}/questions/${id}`)
  return response.data
}

export const postTestQuestion = async (data) => {
  const response = await api.post(`${servicePrefix}/questions`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data
}

export const getETestSections = async (params) => {
  const response = await api.get(`${servicePrefix}/sections`, { params: stripEmptyObjects(params) })
  return response.data
}

export const getETestSection = async (id) => {
  const response = await api.get(`${servicePrefix}/sections/${id}`)
  return response.data
}

export const postETestSection = async (data) => {
  const response = await api.post(`${servicePrefix}/sections`, data)
  return response.data
}

export const updateETestSection = async (id, data) => {
  const response = await api.put(`${servicePrefix}/sections/${id}`, data)
  return response.data
}

export const updateTestQuestion = async (id, data) => {
  const response = await api.patch(`${servicePrefix}/questions/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data
}

export const searchDrivingTestBookingBySearchTerm = async (searchTerm, testDate) => {
  const response = await api.get(`${servicePrefix}/test-bookings/search/${searchTerm}?testDate=${testDate}`)

  return response.data
}

export const getTheoryTestByBookingId = async (id) => {
  const response = await api.get(`${servicePrefix}/test-bookings/${id}/theory-test`)
  return response.data
}

export const getQuizScoreByBookingId = async (id) => {
  const response = await api.get(`${servicePrefix}/test-bookings/${id}/quiz-score`)
  return response.data
}

export const postMarksheet = async (data) => {
  const response = await api.post(`${servicePrefix}/marksheets`, data)

  return response.data
}

export const getMarksheetByBookingId = async (testBookingId) => {
  const response = await api.get(`${servicePrefix}/marksheets/get-marksheet-by-booking-id/${testBookingId}`)

  return response.data
}

export const getTestBookingById = async (id) => {
  const response = await api.get(`${servicePrefix}/test-bookings/${id}`)
  return response.data
}

export const getTheoryRecheckByBookingId = async (id) => {
  const response = await api.get(`${servicePrefix}/test-bookings/${id}/theory-recheck`)
  return response.data
}

export const getQuizRecheckByBookingId = async (id) => {
  const response = await api.get(`${servicePrefix}/test-bookings/${id}/quiz-recheck`)
  return response.data
}

//Learner theory test sessions
const theory = `${servicePrefix}/learner-theory-sessions`

export const getLearnerTheorySessions = async (params) => (await api.get(theory, { params: stripEmptyObjects(params) })).data
export const getLearnerTheorySession = async (id) => (await api.get(`${theory}/${id}`)).data
export const addLearnerTheorySession = async (data) => (await api.post(theory, data)).data
export const cancelLearnerTheorySession = async (id) => (await api.patch(`${theory}/${id}/cancel`)).data
export const getLearnerTheoryCandidates = async (id) => (await api.get(`${theory}/${id}/candidates`)).data
export const startLearnerTheorySession = async (id) => (await api.post(`${theory}/${id}/start`)).data
export const completeLearnerTheorySession = async (id) => (await api.post(`${theory}/${id}/complete`)).data
export const resendLearnerTheoryCode = async (bookingId) => (await api.post(`${theory}/bookings/${bookingId}/resend-code`)).data
export const markLearnerTheoryAbsent = async (bookingId) => (await api.patch(`${theory}/bookings/${bookingId}/absent`)).data
export const getLearnerTheoryResults = async (params) => (await api.get(`${theory}/results`, { params: stripEmptyObjects(params) })).data

const DrivingTestService = {
  getLearnerTheorySessions,
  getLearnerTheorySession,
  addLearnerTheorySession,
  cancelLearnerTheorySession,
  getLearnerTheoryCandidates,
  startLearnerTheorySession,
  completeLearnerTheorySession,
  resendLearnerTheoryCode,
  markLearnerTheoryAbsent,
  getLearnerTheoryResults,

  getDrivingTestConfigurations,
  addDrivingTestConfiguration,
  getDrivingTestConfiguration,
  getDrivingTestConfigurationWithBookings,
  getDrivingTestCandidatesByTestConfigurationId,
  updateDrivingTestConfiguration,
  deleteDrivingTestConfiguration,

  getDrivingTestCandidates,
  getDrivingTestCandidate,

  getTestQuestions,
  getTestQuestion,
  postTestQuestion,
  updateTestQuestion,

  getETestSections,
  getETestSection,
  postETestSection,
  updateETestSection,

  searchDrivingTestBookingBySearchTerm,
  getTheoryTestByBookingId,
  getQuizScoreByBookingId,

  postMarksheet,
  getMarksheetByBookingId,
  getTestBookingById,
  getTheoryRecheckByBookingId,
  getQuizRecheckByBookingId
}

export default DrivingTestService
